// extracted by mini-css-extract-plugin
export default {"quiz_question":"TZ","question_subheader":"UZ","why_popup":"VZ","why_underline":"WZ","MyClassEnterDone":"XZ","WhyAskEnterDone":"YZ","WhyUnderlineEnterDone":"ZZ","main_question":"a-"};
    if(module.hot) {
      // 1711394580078
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  